<template>
  <div class="section">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Header></Header>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="bg-white">
            <h2>All Active Client List {{ client.length }}</h2>
            <div class="row mt-5">              
              <div class="col-md-4 mb-3" v-for="c in client" :key="c.id">
                <div class="card">
                    <div class="card-header">{{ c.company_name }}</div>
                    <div class="card-body d-flex justify-content-around">
                      <a :href="'/'+c.id+'/ticket-form'" class="btn btn-info"> Create Ticket</a>
                      <!-- <a v-if="c.active_projects.length > 0" :href="'/'+c.id+'/request-form'" class="btn btn-success"> Create Task</a>-->
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>              
      </div>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
export default {
  components: {
    Header
  },
  data(){
    return{
      client: [],
      projects: [],
    }
  },
  mounted () {
    fetch('https://xtservicedesk.com/api/v1/clients')
      .then((res) => res.json())
      .then((result) => {
        this.client = result.data
        this.projects = result.data.active_projects
      })
  }
}
</script>
